export enum ComoManagedGiftType {
  REWARD = 'reward',
  POINT_SHOP_GIFT = 'point_shop_gift',
}
